import ConfigurationsService from '../../services/configurations.service';

export const state = {
  permissions: null
};

export const actions = {
  async getPermissions({ commit }) {
    try {
      let { data: permissions } = await ConfigurationsService.getConfigurationProfile();
      commit('SET_PERMISSIONS', permissions);
    } catch (err) {
      console.error(err);
    }
  }
};
export const getters = {
  permissions(state) {
    return state.permissions;
  }
};
export const mutations = {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  }
};
